module.exports = __webpack_public_path__ + "static/media/u1F60E.cfb0b7a3.png";